import { apiRequest } from "@portal/lib/ky/utils";
import { DisputeListFilters } from "@portal/store/Filters/dipsutes/type";
import {
  CreateDispute,
  DisputeDetails,
  DisputeList,
  DisputeParams,
  DisputeTypes,
} from "@portal/types/entities/dispute";
import { PageList } from "@portal/types/page-list";
import { RequestConfig } from "../types/common";

export async function getDisputeList(
  params: RequestConfig<DisputeListFilters>
) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<DisputeListFilters>["filters"],
    PageList<DisputeList, unknown>
  >({
    method: "POST",
    url: "v1/disputes/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function getDisputeTypes(params?: Partial<DisputeParams>) {
  const data = await apiRequest<unknown, PageList<DisputeTypes, unknown>>({
    method: "GET",
    url: "v1/disputes/types",
    searchParams: { ...params },
  });
  return await data.json();
}

export async function raiseADispute(params: CreateDispute) {
  const data = await apiRequest<CreateDispute, DisputeDetails>({
    method: "POST",
    url: "v1/disputes",
    data: { ...params },
  });
  return await data.json();
}

export async function updateADispute(
  params: Partial<CreateDispute>,
  id?: string
) {
  const data = await apiRequest<Partial<CreateDispute>, DisputeDetails>({
    method: "PUT",
    url: `v1/disputes/${id}`,
    data: { ...params },
  });
  return await data.json();
}
export async function updateDisputeStatus(
  params: Partial<CreateDispute>,
  id?: string
) {
  const data = await apiRequest<Partial<CreateDispute>, DisputeDetails>({
    method: "PATCH",
    url: `v1/disputes/${id}`,
    data: { ...params },
  });
  return await data.json();
}
export async function getDisputeDetails(params?: string) {
  const data = await apiRequest<unknown, DisputeDetails>({
    method: "GET",
    url: `v1/disputes/${params}`,
  });
  return await data.json();
}

export async function deleteADispute(id?: string) {
  await apiRequest<unknown, undefined>({
    method: "DELETE",
    url: `v1/disputes/${id}`,
  });
}
